/* eslint-disable camelcase */

import { defaultTo, get } from 'lodash-es';

import page from '@/mixins/page';
import pagination from '@/mixins/pagination';
// import { TToggleButton } from '@/components/TToggle';

// console.log(TToggleButton);

/**
 * @module pages/invest/invest020
 * @desc 재무정보 > 공시정보
 * @vue-data {Object} dis=null - 리스트 페이지 통신 결과값 저장
 * @vue-data {Number} year=Number - 현재 년도
 * @vue-data {Array} options=[]] - 셀렉트 박스 년도 목록
 * @vue-data {Boolean} moreBtn=true - 더보기 버튼의 유무
 * @vue-data {Number} yearTo=null - 리스트의 표시할 년도
 */
// 
export default {
  mixins: [page, pagination],
  data() {
    return {
      view: {
        LIST  : 'list',
        DETAIL: 'detail'
      },
      list: {
        TOTL_COUNT: 5
      },
      dis       : null,
      moreBtn   : true,
      viewMode  : null,
      tabID     : '0',
      // '' 전체
      //ethical 윤리경영
      //share 나눔경영
      //environment 환경경영
      //safety 안전경영
      tabList   : ['all', 'ethical', 'share', 'environment', 'safety'],
      seq       : null,
      urlSearch : null,
      currentLen: 0
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.tabID = '0';
      this.viewMode = this.view.LIST;

      window.addEventListener('hashchange', this.hashChangeHandler);

      if (window.location.hash.length) {
        this.hashChangeHandler();
      } else {
        this.loadDisInfo();
      }
    });
  },
  watch: {

    urlSearch(param) {
      // this.viewMode = param.get('viewMode');
      let viewMode = param.get('viewMode');
      if (!viewMode) {
        viewMode = this.view.LIST;
      }

      this.viewMode = viewMode;
      
      if (this.viewMode === this.view.LIST) {
        let tabID = param.get('tabID');
        // let groupID = true;

        if (!tabID) {
          tabID = 0;
          // groupID = false;
        }

        // console.log(window.location);
        // let pageN = param.get('pageN');
        // if (pageN) {
        //   groupID = false;
        // }

        this.tabID = tabID;

        this.loadDisInfo();
        // console.log('url serach === ');
      } else {
        
        let seq = param.get('seq');
        if (!seq) {
          seq = 0; 
        }

        this.seq = seq;

        this.loadDetailInfo();
      }
    }
  },
  methods: {
    // setSearch() {
    //   this.urlSearch = new URLSearchParams(window.location.hash);
    // },
    /**
     * 공시정보 번호 폼에 맞춰 replace
     * @param {String} value 변환 할 문자열
     * @returns 폼에 맞게 html 변환 후 반환
     */
    getNo(value) {
      // console.log('x ;;; x ', value);
      // 'ethical', 'share', 'environment', 'safety'

      let str;
      if (value === 'ethical') {
        str = '윤리경영';
      }

      if (value === 'share') {
        str = '나눔경영';
      }

      if (value === 'environment') {
        str = '안전·보건·환경';
      }

      if (value === 'safety') {
        str = '품질경영';
      }


      return str;
      // return value.replaceAll(/^(\d{8})(\d+)$/g, '$1<br />$2');
    },
    /**
     * 날짜 replace
     * @param {String} value 변환 할 문자열
     * @returns 입력값 yyyy-mm-dd 으로 변환 후 반환
     */
    getDate(value) {
      // return value.replaceAll(/^(\d{4})(\d{2})(\d{2})$/g, '$1-$2-$3');

      return value.split(' ')[0];
    },
    /**
     * 문자열에서 숫자 추출
     * @param {String} value 변환 할 문자열
     * @returns 문자열에서 숫자만 반환
     */
    getNum(value) {
      return value.replace(/[^0-9]/g, '');
    },
    /**
     * 리스트 페이지 통신
     */
    // group
    loadDisInfo() {
      //ethical 윤리경영
      //share 나눔경영
      //environment 환경경영
      //safety 안전경영
      // getEsgList.do

      let n = this.curPageIdx + 1;

      if (this.device === 'mo') {
        this.loadPageData({
          uri   : '/api/getEsgList.do',
          params: {
            rowCnt   : this.list.TOTL_COUNT,
            'page_no': n,
            'type'   : this.tabList[this.tabID]
          },
          callback: (res) => {
            // 더보기 버튼
            if (this.listItems !== null) {
              this.listItems = this.listItems.concat(get(res.data, 'result', []));

              const map = new Map();
              for (const character of this.listItems) {
                map.set(JSON.stringify(character), character);
              }

              this.listItems = [...map.values()];
            } else {
              // 초기화
              this.listItems = get(res.data, 'result');
            }

            this.currentLen = 0;
            if (this.listItems) {
              this.currentLen = this.listItems.length;
            }

            this.totalPageN = defaultTo(
              parseInt(get(res.data, 'totalCnt')),
              1
            );
          }
        });
      } else {
        this.loadPageData({
          uri   : '/api/getEsgList.do',
          params: {
            'rowCnt' : this.list.TOTL_COUNT,
            'page_no': n,
            'type'   : this.tabList[this.tabID]
          },
          callback: (res) => {
            this.dis = get(res, 'data');
            this.listItems = get(res.data, 'result', []);
            this.totalPageN = Math.ceil(res.data.totalCnt / this.list.TOTL_COUNT);
          }
        });
      }
    },

    loadDetailInfo() {
      this.axios.get('/api/getEsg.do', {
        params: {
          seq: this.seq
        }
      }).then((res) => {
        get(res.data.result, 'title');

        const file = get(res.data.result, 'file_oriname');

        this.$refs.date.innerHTML = res.data.result.reg_date.split(' ')[0];
        
        this.$refs.title.innerHTML = get(res.data.result, 'title');

        
        this.$refs.boardCon.innerHTML = get(res.data.result, 'content');

        // 다운로드
        if (file) {
          this.$refs.boardAttach.style.display='block';
          this.$refs.attachFileName.innerHTML = get(res.data.result, 'file_oriname');
        } else {
          this.$refs.boardAttach.style.display='none';
        }
      });
    },

    download(seq) {
      this.$system.download(
        `${this.axios.defaults.baseURL}/api/esgDownload.do?seq=${seq}`
      );
    },

    hashChangeHandler() {
      this.urlSearch = new URLSearchParams(window.location.hash.replace('#', ''));
    },

    /**
     * 공시정보 오픈
     * @param {String} num 문서 번호
     */
    clickBbs(num) {
      this.seq = num;
      const search = new URLSearchParams();
      search.set('viewMode', this.view.DETAIL);
      search.set('seq', num);

      window.location.hash = search.toString();
    },

    tabClick(num) {
      const search = new URLSearchParams();
      search.set('tabID', num);

      this.listItems = null;

      this.curPageIdx = 0;

      window.location.hash = search.toString();
    },

    listView() {
      if (this.device === 'mo') {
        // this.listItems = null;
      }
      window.history.back();
    }
  }
};